import ServiceCard from "component/home/services/components/service-card";

export default function NewToolsSection({ newTools }) {
  if (!newTools.length) return null;

  return (
    <div className="row">
      {newTools.map(
        (
          {
            id,
            title,
            shortDescription,
            link,
            isInternal,
            serviceAndToolTranslation,
            isSystem,
          },
          index,
        ) => (
          <div key={index} className="col-md-6">
            <ServiceCard
              title={title}
              description={shortDescription}
              link={link}
              serviceAndToolTranslation={serviceAndToolTranslation}
              isInternal={isInternal}
              isSystem={isSystem}
              id={id}
            />
          </div>
        ),
      )}
    </div>
  );
}
